<template>
  <div class="entriy_detail_container">
    <div class="back">
      <span class="back-arrow" @click="$router.back(-1)">
        <Icon iconClass="arrow-left2" />
      </span>
      <span>作品详情</span>
    </div>
    <div class="entriy_detail_box" v-if="!!detail">
      <div class="title" v-text="detail.title"></div>
      <div class="junior clearfix">
        <span class="member"><span v-text="detail.serialNumber"></span>号-<span v-text="detail.memberNickName"></span></span>
        <span class="time" v-text="detail.applyTime"></span>
      </div>
      <div class="entriy_apply_form_list">
        <div class="apply_form_item" v-for="(item,index) in detail.custom" :key="index">
          <div class="label" v-text="item.displayName" v-if="item.displayName&&item.displayName.length>0"></div>
          <div class="label" v-text="'视频'" v-else-if="item.customType==5 && item.fileType==1"></div>
          <div class="label" v-text="'音频'" v-else-if="item.customType==5 && item.fileType==2"></div>
          <div class="label" v-text="'图片'" v-else-if="item.customType==5 && item.fileType==3"></div>
          <!-- 单行文本 -->
          <div class="form_item_value" v-if="item.customType==1">
            <div class="item_text">
              <span v-text="item.value"></span>
            </div>
          </div>
          <!-- 多行文本 -->
          <div class="form_item_value" v-else-if="item.customType==2">
            <div class="item_text">
              <span v-text="item.value"></span>
            </div>
          </div>
          <!-- 单选按钮 -->
          <div class="form_item_value" v-else-if="item.customType==3">
            <van-radio-group>
              <van-radio checked-color="#397ef5">{{item.value}}</van-radio>
            </van-radio-group>
          </div>
          <!-- 多选按钮 -->
          <div class="form_item_value" v-else-if="item.customType==4">
            <!-- <span v-text="item.value"></span> -->
            <ul class="tag_list clearfix">
              <li class="tag_item" v-text="tag" v-for="(tag,idx) in item.value" :key="idx"></li>
            </ul>
          </div>
          <!-- 附件上传 上传文件的类型:1.视频2.音频3.图片，该字段为空时表示不限制 -->
          <div class="form_item_value" v-else-if="item.customType==5">
            <div class="value_box" v-if="item.fileType==1">
              <div class="video_item" v-for="video in item.value" :key="video.resourceId">
                <video controls controlslist="nodownload" disablepictureinpicture :src="video.url" :poster="video.coverUrl"></video>
              </div>
            </div>
            <div class="value_box" v-else-if="item.fileType==2">
              <div class="audio_item" v-for="audio in item.value" :key="audio.resourceId">
                <audio controls controlslist="nodownload" :src="audio.url">亲 您的浏览器不支持html5的audio标签</audio>
              </div>
            </div>
            <div class="value_box" v-else-if="item.fileType==3">
              <div class="pic_item" v-for="pic in item.value" :key="pic.resourceId">
                <img :src="pic.url" alt="">
              </div>
            </div>
          </div>
          <!-- 下拉列表 -->
          <div class="form_item_value" v-else-if="item.customType==6">
            <div class="item_text">
              <span v-text="item.value"></span>
            </div>
          </div>
          <!-- 二级下拉 -->
          <div class="form_item_value" v-else-if="item.customType==8">
            <div class="item_text">
              <span v-text="item.value"></span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="operate_box" v-if="!!detail">
      <span>作品已获得
        <van-icon name="like-o" /><span v-text="detail.topTimes"></span>票
      </span>
      <span class="operate_btn" @click="vote($event)">为TA投票</span>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { loadStat } from "@/utils";
import activityApi from "@/api/apis/activity.js";
import commApi from "@/api/apis/common.js";
export default {
  name: "EntriyDetail",
  data() {
    return {
      applyFormId: null,
      contentType: "activity_work_detail",
      detail: null,
      custom: null,
      shareUrl: "",
    };
  },
  computed: {
    ...mapState("app", ["userInfo", "nodeCode"]),
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (from.path == "/index_share") {
        vm.shareUrl = location.href.replace("/entriy_detail?", "/index_share?");
      } else {
        vm.shareUrl = location.href;
      }
    });
  },
  methods: {
    /* 微信二次分享 */
    wechatShare() {
      var _this = this;

      commApi.getWeiXinTicket({
        nodeCode: _this.nodeCode,
        url: _this.shareUrl
      }).then((res) => {
        var shareTitle = _this.detail.shareTitle.replace("{NAME}", _this.detail.memberNickName).replace("{NO}", _this.detail.serialNumber);
        document.title = shareTitle;
        var shareImg = null;
        if (!!_this.detail.profile && _this.detail.profile.length > 0) {
          shareImg = _this.detail.profile;
        } else if (!!_this.detail.pictures && _this.detail.pictures.length > 0) {
          shareImg = _this.detail.pictures[0].url;
        } else if (!!_this.detail.video && _this.detail.video.length > 0) {
          shareImg = _this.detail.video[0].coverUrl
        }
        _this.$WeiXin.shareWeiXin(res, shareTitle + " - 法治号客户端", _this.detail.title, _this.shareUrl, shareImg);
      }).catch((err) => {

      })
    },
    /* 参赛作品详情 */
    getApplyFormDetail() {
      var _this = this;
      var params = {
        applyFormId: _this.applyFormId,
      };
      if (_this.userInfo) {
        params.loginMemberId = _this.userInfo.id;
      }
      activityApi
        .getApplyFormDetail(params)
        .then((res) => {
          if (res.suc == 1) {
            _this.detail = res.data;
            let list = res.data.custom;
            for (var i = 0; i < list.length; i++) {
              if (list[i].customType == 4 && list[i].value.length > 0) {
                list[i].value = JSON.parse(list[i].value);
              }
            }
            _this.custom = list;
            _this.wechatShare(); // 微信二次分享
          }
        })
        .catch((err) => {
          _this.$toast({
            message: "接口调用出错",
            position: "center",
          });
        });
    },
    /* 投票 */
    vote(event, data) {
      var _this = this;

      if (!_this.userInfo) {
        this.$router.push("/login");
        return;
      }

      var clsArray = event.currentTarget.classList;
      if (clsArray.contains("voted_btn")) {
        return;
      }

      var params = {
        applyFormId: _this.applyFormId,
        memberId: _this.userInfo.id,
        voteSourceType: 1, //来源的客户端  1、分享页     2、app
      };
      activityApi
        .topApplyForm(params)
        .then((res) => {
          if (res.suc == 0) {
            clsArray.add("voted_btn");
            _this.$toast({
              message: res.message || res.text,
              position: "center",
            });
          } else if (res.suc == 1) {
            _this.getApplyFormDetail();
            if (_this.detail.topRelatedRaffleId > 0) {
              _this.$dialog
                .confirm({
                  message: "投票成功，恭喜您获得一次抽奖机会，现在去抽奖？",
                  cancelButtonText: "放弃",
                  confirmButtonText: "去抽奖",
                })
                .then(() => {
                  _this.$router.replace({
                    path: "/raffle_detail",
                    query: {
                      contentType: 2,
                      freeFlag: 1,
                      drawRaffleId: _this.detail.topRelatedRaffleId,
                      type: 0,
                    },
                  });
                })
            } else {
              _this.$toast({
                message: res.message || res.text,
                position: "center",
              });
            }
          }
        })
        .catch((err) => {
          _this.$toast({
            message: "接口调用出错",
            position: "center",
          });
        });
    },
  },
  created() {
    document.title = "作品详情";
    let query = this.$route.query;
    if (Object.prototype.hasOwnProperty.call(query, "applyFormId")) {
      this.applyFormId = query.applyFormId;
      this.contentType = !!query.contentType ? query.contentType : "activity_work_detail";
      this.getApplyFormDetail();
      loadStat(); // 友盟统计
    } else {
      this.$router.replace({
        path: "/error",
      });
    }
  },
};
</script>
<style scoped lang="scss">
.entriy_detail_container {
  position: relative;
  width: 100%;
  height: 100%;
  background-color: #fff;
  overflow: hidden;
  .entriy_detail_box {
    position: relative;
    width: 100%;
    height: calc(100% - 87px);
    padding: 15px;
    overflow-x: hidden;
    overflow-y: auto;
    // background-color: #f6f6f6;
    .title {
      color: #333;
      font-size: 20px;
      font-weight: bold;
    }
    .junior {
      height: 42px;
      padding-top: 10px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      span {
        line-height: 32px;
        color: #646464;
        &.member {
          color: #666;
          font-size: 14px;
        }
        &.time {
          float: right;
          color: #8e8e8e;
          font-size: 12px;
        }
      }
    }
    .entriy_apply_form_list {
      margin-top: 15px;
      .apply_form_item {
        .label {
          position: relative;
          height: 36px;
          padding-left: 15px;
          padding-right: 10px;
          line-height: 36px;
          overflow: hidden;
          &:before {
            position: absolute;
            left: 0;
            top: 9px;
            display: block;
            width: 5px;
            height: 18px;
            background-color: #397ef5;
            content: "";
          }
        }
        .form_item_value {
          width: 100%;
          overflow: hidden;
          .item_text {
            margin-left: 15px;
            margin-bottom: 10px;
          }
          .van-radio-group {
            margin-left: 15px;
          }
          .tag_list {
            padding-top: 5px;
            padding-bottom: 3px;
            margin-left: 15px;
            .tag_item {
              float: left;
              min-width: 45px;
              height: 30px;
              line-height: 30px;
              padding-left: 8px;
              padding-right: 8px;
              background-color: #397ef5;
              margin-right: 12px;
              margin-bottom: 12px;
              color: #fff;
              text-align: center;
              font-size: 14px;
              border-radius: 5px;
            }
          }
          .value_box {
            .video_item {
              width: 100%;
              margin-bottom: 10px;
              video {
                display: block;
                width: 100%;
                background-color: #000;
                overflow: hidden;
              }
            }
            .audio_item {
              width: 100%;
              margin-bottom: 10px;
              audio {
                display: block;
                width: 100%;
                overflow: hidden;
              }
            }
            .pic_item {
              width: 100%;
              margin-bottom: 10px;
              img {
                display: block;
                width: 100%;
                overflow: hidden;
              }
            }
          }
        }
      }
    }
  }
  .operate_box {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 5;
    width: 100%;
    height: 43px;
    line-height: 32px;
    padding: 5px 15px;
    background-color: #fff;
    border-top: 1px solid #ebedf0;
    color: #666;
    font-size: 12px;
    .operate_btn {
      float: right;
      height: 32px;
      width: 128px;
      line-height: 32px;
      background: -webkit-linear-gradient(#41adfe, #037efd);
      background: -o-linear-gradient(#41adfe, #037efd);
      background: -moz-linear-gradient(#41adfe, #037efd);
      background: linear-gradient(#41adfe, #037efd);
      border-radius: 5px;
      text-align: center;
      color: #fff;
      font-size: 14px;
      &.voted_btn {
        background: #99bbdb;
      }
    }
  }
}
</style>